import useCurrentGroupId from "@Totum/Groups/State/hooks/useCurrentGroupId";
import { useRemoveGroupMembers } from "@Totum/Groups/State/mutations";
import { useGroupUsersQuery, useUsersQuery } from "@Totum/Groups/State/queries";

/**
 * Orchestrates the operations for the `Search List` component.
 */
const useUserListOperations = (
    currentPage?: number,
    pageSize?: number,
    searchTerm?: string,
    activeTabKey?: string,
    isGroupAdmin?: boolean
) => {
    // ** Constants & Variables ** //
    const [currentGroupId] = useCurrentGroupId();
    // ** Hooks ** //
    const { data: groupUsers, ...otherGroupUsersQueryProps } = useGroupUsersQuery(
        currentGroupId,
        currentPage,
        pageSize,
        searchTerm,
        isGroupAdmin
    );

    const { data: Users, ...otherUsersQueryProps } = useUsersQuery(
        currentPage,
        pageSize,
        searchTerm,
        activeTabKey,
        isGroupAdmin
    );
    const removeGroupMember = useRemoveGroupMembers(currentGroupId);

    // ** Constants & Variables ** //
    const groupUsersIndividual = groupUsers?.isSuccess ? groupUsers.value : undefined;
    const allUsers = Users?.isSuccess ? Users.value : undefined;

    // ** Exports ** //

    return {
        // data
        groupUsers: groupUsersIndividual,
        allUsers,

        // state
        isFetchingGroupUsers: otherGroupUsersQueryProps.isFetching,
        isFetchingAllUsers: otherUsersQueryProps.isFetching,

        //methods
        removeGroupMember,
    };
};

export default useUserListOperations;
